import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Divider from 'components/Divider/Divider';
import { Title, Header } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import Email from '../Email/Email';
import Phone from '../Phone/Phone';
import ProfileItem from '../ProfileItem';
export default function CompanyInfo() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  if (!customer) return /*#__PURE__*/React.createElement(Title, null, t('profile.no_profile'));
  return /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Header, null, t('profile.company')), /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('profile.organization_name'),
    value: customer.organizationName
  }), /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('profile.organization_number'),
    value: customer.organizationNumber
  }), /*#__PURE__*/React.createElement(Email, {
    fieldName: "email"
  }), /*#__PURE__*/React.createElement(Phone, {
    fieldName: "phoneNumber"
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Title, null, t('profile.contact_info')), customer.contactName && /*#__PURE__*/React.createElement(ProfileItem, {
    label: t('profile.contact_person'),
    value: customer.contactName
  }));
}